import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ProductActionType } from '../actions';
import * as ProductActions from '../actions';
import { switchMap, map, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OdooAPI } from 'src/app/services/odoo/services/odooAPI';
import { Store } from '@ngrx/store';
import { ProductState } from '..';
import * as ProductSelectors from '../selectors';
import { productFields } from '../../model';

@Injectable()
export class ProductEffects {
  constructor(
    private actions$: Actions,
    private odooAPI: OdooAPI,
    private productStore: Store<ProductState>,
    ) {}

  @Effect()
  loadHttp$ = this.actions$.pipe(
    ofType(ProductActionType.LOAD_HTTP),
    mergeMap((loadHTTPAction: ProductActions.LoadHttp) => {
      return of(loadHTTPAction.payload);
    }),
    withLatestFrom(     
      this.productStore.select(ProductSelectors.selectOffset),
      this.productStore.select(ProductSelectors.selectLimit),
      this.productStore.select(ProductSelectors.selectSearch),
    ),
    mergeMap(([payload,offset,limit,search]) => {
      let newPayload={...payload}
      if(!newPayload.model)
      newPayload['model']="storex_modules.product"
      if(!newPayload.offset && typeof newPayload.offset != "number")
      newPayload.offset=offset
      if(!newPayload.limit)
      newPayload.limit=limit
      if(!newPayload.search)
      newPayload.search=search
      if(!newPayload.fields)
      newPayload.fields=productFields
      
      return this.odooAPI
        .loadPublicRecords(newPayload)
        .pipe(
          map(
            (data: any) => {
              
              return new ProductActions.LoadHttpSuccess(data);
            },
            err => {
              return new ProductActions.LoadHttpFail(err);
            }
          ),
        catchError(err => {
          return of(new ProductActions.LoadHttpFail(err));
        })
        )
    })
  );

  @Effect()
  updateSearch$ = this.actions$.pipe(
    ofType(ProductActionType.UPDATE_SEARCH),
    switchMap((updateSearchAction: ProductActions.UpdateSearch) =>
      of(updateSearchAction.search)
    ),
    switchMap((search: any) => {
      return of(new ProductActions.LoadHttp({}));
    })
  );
}
